import { OrgDepartmentRoles } from '../../graphql/generated/types';
import { TModelOptionLabels } from '../types';

export const orgDepartmentRoleLabels: TModelOptionLabels<OrgDepartmentRoles> = {
  [OrgDepartmentRoles.Finance]: 'Financeiro',
  [OrgDepartmentRoles.ExecutiveBoard]: 'Diretoria',
};
